export enum LoanRule {
  AGGREGATE_RULE_VERSION = "AGGREGATE_RULE_VERSION",
  RULE_VERSION = "RULE_VERSION",
  BASE_PRICE = "BASE_PRICE",
  SERVICER_FEES = "SERVICER_FEES",
  DD_FEES = "DD_FEES",
  SETTLEMENT_RULE = "SETTLEMENT_RULE",
  OVERLAYS = "OVERLAYS",
  RATE_SHEET = "RATE_SHEET",
  CREDIT_RESERVE_HOLDBACK = "CREDIT_RESERVE_HOLDBACK",
  RATE_ADJUSTMENTS = "RATE_ADJUSTMENTS",
  LOCATION_ADJUSTMENT = "LOCATION_ADJUSTMENT",
  LH_BUCKET = "LH_BUCKET",
  GROUNDUP_ADJUSTMENT = "GROUNDUP_ADJUSTMENT",
  REFINANCE_ADJUSTMENT = "REFINANCE_ADJUSTMENT"
}
